import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import img from '../../../images/home.png';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import iconReport from '../../../images/icon-3.png';
import iconApproval from '../../../images/icon-4.png';
import ScheduleIconWhite from "../../../images/schedule-icon-white.png";
import ShipIconWhite from "../../../images/ship-icon-white.png";
import CheckListIconWhite2 from '../../../images/check-list-white.png';
import Skeleton from '@material-ui/lab/Skeleton';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

import Api from "../../../libraries/api";

const SHOW_SUMMARY_OF_COST_COLUMN = false;

const LIFECYCLE_QUERY_KEYS = {
    approval: 'approval_status_ids',
    survey: 'case_survey_status_ids',
    masterCase: 'cases_status_ids',
    summaryOfCost: 'summary_of_cost_ids',
};

const COLUMN_ICONS = {
    approval: iconApproval,
    survey: ScheduleIconWhite,
    masterCase: ShipIconWhite,
    summaryOfCost: iconReport,
};

function normalizeLifecycleItems(items) {
    if (!Array.isArray(items)) return [];

    return items
        .map((item) => ({
            id: item?.id,
            name: item?.name ?? '',
            count: Number(item?.count ?? 0),
        }))
        .filter((item) => item.id != null);
}

function normalizeLifecycleBucket(resp) {
    const root = resp?.data ?? resp;
    if (!root || typeof root !== 'object' || Array.isArray(root)) return {};

    if (root.data && typeof root.data === 'object' && !Array.isArray(root.data)) {
        return root.data;
    }

    return root;
}

function pickDashboardTotal(resp) {
    const data = resp?.data;
    if (Array.isArray(data)) {
        if (data.length === 0) return 0;
        return Number(data[0]?.total ?? 0);
    }
    if (data && typeof data === 'object' && data.total !== undefined) {
        return Number(data.total ?? 0);
    }
    return 0;
}

class ContentDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            approval_status: [],
            case_survey_status: [],
            master_case_status: [],
            summary_of_cost: [],

            dataReportOnProgress: 0,
            dataApprovalOnProgress: 0,
            loadingLifecycle: true,
            loadingSummary: true,
        };
    }

    componentDidMount() {
        document.title = 'Abadi - Dashboard';

        Promise.all([
            Api.get('/dashboards/projects/lifecycle-relation-counts'),
            Api.get('/dashboards/count-report'),
            Api.get('/dashboards/count-approval'),
        ]).then(([lifecycleResp, reportResp, approvalResp]) => {
            const bucket = normalizeLifecycleBucket(lifecycleResp);

            this.setState({
                approval_status: normalizeLifecycleItems(bucket.approval_status),
                case_survey_status: normalizeLifecycleItems(bucket.case_survey_status),
                master_case_status: normalizeLifecycleItems(bucket.master_case_status),
                summary_of_cost: normalizeLifecycleItems(bucket.summary_of_cost),
                dataReportOnProgress: pickDashboardTotal(reportResp),
                dataApprovalOnProgress: pickDashboardTotal(approvalResp),
                loadingLifecycle: false,
                loadingSummary: false,
            });
        }).catch(() => {
            this.setState({ loadingLifecycle: false, loadingSummary: false });
        });
    }

    filterHref = (queryKey, id, title) => {
        const safeTitle = encodeURIComponent(title || '');
        return `/projects-filter?${queryKey}=${id}&title=${safeTitle}`;
    };

    renderFloatingButtonMyTask = () => {
        let redirectUrl = '/my';

        return (
            <Link to={redirectUrl} target='_blank'>
                <Tooltip title="Pergi ke My Task" arrow>
                    <Fab className="fab-my-task" color="secondary" >
                        <img src={CheckListIconWhite2} alt='todo' width={35} />
                    </Fab>
                </Tooltip>
            </Link>
        );
    };

    renderLifecycleCard = (cardClass, iconSrc, item, queryKey) => (
        <Link key={item.id} to={this.filterHref(queryKey, item.id, item.name)} target='_blank'>
            <div className={`card-info ${cardClass}`}>
                <div className="row align-items-center">
                    <div className="col-3 pr-0">
                        <div className="wrap square d-flex justify-content-center align-items-center">
                            <img src={iconSrc} alt='dashboard' className="img-icon" />
                        </div>
                    </div>
                    <div className="col-8 col-md-10 col-xl-8">
                        <label className="label-grey">{item.name}</label>
                        {this.state.loadingLifecycle ? (
                            <Skeleton variant="text" />
                        ) : (
                            <p className="number">{item.count ?? 0}</p>
                        )}
                    </div>
                    <div className="col-1 pl-0"><ChevronRightIcon /></div>
                </div>
            </div>
        </Link>
    );

    renderLifecycleColumn = (title, items, cardClass, columnKey) => {
        const queryKey = LIFECYCLE_QUERY_KEYS[columnKey];
        const iconSrc = COLUMN_ICONS[columnKey];

        return (
            <div className="col-md-3">
                <h3 className='title-wrap'>{title}</h3>
                {(items || []).map((item) =>
                    this.renderLifecycleCard(cardClass, iconSrc, item, queryKey)
                )}
            </div>
        );
    };

    renderProjectSummaryColumn = () => (
        <div className="col-md-3">
            <h3 className='title-wrap'>PROJECT SUMMARY</h3>
            <Link to="/projects-filter?typeId=647bbf15-c72a-4cdc-bace-464c5368e325&status=onp&title=Report On Progress" target='_blank'>
                <div className="card-info green">
                    <div className="row align-items-center">
                        <div className="col-3 pr-0">
                            <div className="wrap square">
                                <img src={iconReport} alt='dashboard' className="img-icon" />
                            </div>
                        </div>
                        <div className="col-8 col-md-10 col-xl-8">
                            <label className="label-grey">Report On Progress</label>
                            {this.state.loadingSummary ? (
                                <Skeleton variant="text" />
                            ) : (
                                <p className="number">{this.state.dataReportOnProgress}</p>
                            )}
                        </div>
                        <div className="col-1 pl-0"><ChevronRightIcon /></div>
                    </div>
                </div>
            </Link>
            <Link to="/projects-filter?typeId=80e0e031-4932-466d-93c5-107ffd361218&status=onp&title=Approval On Progress" target='_blank'>
                <div className="card-info green">
                    <div className="row align-items-center">
                        <div className="col-3 pr-0">
                            <div className="wrap square">
                                <img src={iconApproval} alt='dashboard' className="img-icon" />
                            </div>
                        </div>
                        <div className="col-8 col-md-10 col-xl-8">
                            <label className="label-grey">Approval On Progress</label>
                            {this.state.loadingSummary ? (
                                <Skeleton variant="text" />
                            ) : (
                                <p className="number">{this.state.dataApprovalOnProgress}</p>
                            )}
                        </div>
                        <div className="col-1 pl-0"><ChevronRightIcon /></div>
                    </div>
                </div>
            </Link>
        </div>
    );

    render() {
        const {
            approval_status,
            case_survey_status,
            master_case_status,
        } = this.state;

        return (
            <div className="row main-content">

                {this.renderFloatingButtonMyTask()}

                <div className="col-12 px-lg-5">
                    <h2 className="page-title">Dashboard</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Dashboard</li>                        </ol>
                    </nav>

                    <div className="card-home mb-3">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-7 ">
                                <blockquote>Welcome Back!</blockquote>
                                <p>Selalu langsung cek "My Task" masing - masing, update setiap project yang ada. Buat apa yang akan dikerjakan di event setiap pagi sebelum bekerja.</p>
                            </div>
                            <div className="col-md-5 col-lg-4">
                                <img src={img} alt='welcome' className="img-fluid" />
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        {this.renderProjectSummaryColumn()}
                        {this.renderLifecycleColumn('CASE SURVEY STATUS', case_survey_status, 'yellow', 'survey')}
                        {this.renderLifecycleColumn('CASE STATUS', master_case_status, 'blue', 'masterCase')}
                        {this.renderLifecycleColumn('APPROVAL STATUS', approval_status, 'red', 'approval')}
                    </div>
                    {SHOW_SUMMARY_OF_COST_COLUMN ? (
                        <div className="row">
                            {this.renderLifecycleColumn(
                                'SUMMARY OF COST',
                                this.state.summary_of_cost,
                                'green',
                                'summaryOfCost'
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default ContentDashboard;
